// src/components/Product/ProductCard/FavoriteButton.js 
import React, { useState } from 'react'; 
import { IconButton, Tooltip } from '@mui/material'; 
import { Favorite, FavoriteBorder } from '@mui/icons-material'; 
import { useFavorites } from '../../../contexts/FavoritesContext'; 
 
const FavoriteButton = ({ productId, isMobile }) => { 
  const { isFavorite, toggleFavorite } = useFavorites(); 
  const [loading, setLoading] = useState(false); 
 
  const handleToggleFavorite = async (e) => { 
    e.preventDefault(); 
    e.stopPropagation(); 
     
    setLoading(true); 
     
    try { 
      await toggleFavorite(productId); 
    } catch (error) { 
      console.error('Error toggling favorite:', error); 
    } finally { 
      setLoading(false); 
    } 
  }; 
 
  return ( 
    <Tooltip title={isFavorite(productId) ? 'حذف من المفضلة' : 'إضافة للمفضلة'}> 
      <IconButton 
        onClick={handleToggleFavorite} 
        disabled={loading} 
        aria-label="إضافة إلى المفضلة"
        sx={{ 
          position: 'absolute', 
          top: 8, 
          right: 8, 
          bgcolor: '#f5f5f5',
          '&:hover': { bgcolor: '#e0e0e0' },
          color: '#a72c2a',
          fontSize: '1.5rem',
          // Much lower z-index to ensure it never appears above mobile header 
          zIndex: 10, 
          transition: 'all 0.2s ease-in-out',
          '&:disabled': { 
            opacity: 0.6 
          } 
        }} 
      > 
        {isFavorite(productId) ? ( 
          <Favorite sx={{ fontSize: isMobile ? 20 : 24 }} /> 
        ) : ( 
          <FavoriteBorder sx={{ fontSize: isMobile ? 20 : 24 }} /> 
        )} 
      </IconButton> 
    </Tooltip> 
  ); 
}; 
 
export default FavoriteButton;
